/* eslint-disable no-empty */
import { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import '../gate33-program/g33.css'; // reuse the SAME design system
import { CateringProvider, useCatering } from './CateringContext';
import CateringPasswordGate from './CateringPasswordGate';
import { CateringTopBar, CateringSideRail } from './CateringShell';
import { CateringLanding, CateringModulePage } from './CateringPages';

const Inner = () => {
  const { authed, checking } = useCatering();

  // Block search engines on this confidential program area
  useEffect(() => {
    const tag = document.createElement('meta');
    tag.name = 'robots';
    tag.content = 'noindex, nofollow';
    document.head.appendChild(tag);
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href =
      'https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&family=Playfair+Display:ital,wght@0,300;0,400;0,500;0,600;0,700;1,400;1,600&display=swap';
    document.head.appendChild(link);
    return () => {
      try { document.head.removeChild(tag); } catch {}
      try { document.head.removeChild(link); } catch {}
    };
  }, []);

  if (checking) {
    return (
      <div className="g33-program" style={{
        minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}>
        <div className="g33-eyebrow">Loading…</div>
      </div>
    );
  }

  if (!authed) return <CateringPasswordGate />;

  return (
    <div className="g33-program" data-testid="gate33-catering">
      <CateringTopBar />
      <CateringSideRail />

      <Routes>
        <Route index element={<CateringLanding />} />
        <Route path="module/:slug" element={<CateringModulePage />} />
        <Route
          path="*"
          element={<Navigate to="/gate33-catering-and-operations-training" replace />}
        />
      </Routes>

      <footer style={{
        borderTop: '1px solid var(--g33-ligne)', padding: '32px 16px',
        textAlign: 'center', background: 'var(--g33-cream)',
      }}>
        <p className="g33-eyebrow" style={{ color: 'var(--g33-grey-warm)' }}>
          Gate 33 — Operations &amp; Catering Management · Private aviation
        </p>
      </footer>
    </div>
  );
};

const Gate33Catering = () => (
  <CateringProvider>
    <Inner />
  </CateringProvider>
);

export default Gate33Catering;
